import type { FC } from 'react';
import React from 'react';
import type { TAligns } from '@alfa-bank/site-aligner/src/models';

import type { TStepDesktop } from '../models';
import {
    CENTER,
    DEFAULT_STEP_IMAGE_ALIGN,
    DEFAULT_STEP_TEXT_ALIGN,
    IMAGE_ALIGN_CENTER,
    IMAGE_ALIGN_LEFT,
} from '../../../config';
import { IconArrowRight } from '../../icons/icon-arrow-right';

const getImageColumnsWidth = (imageAlign?: TAligns) =>
    imageAlign === CENTER ? IMAGE_ALIGN_CENTER : IMAGE_ALIGN_LEFT;

export const StepDesktop: FC<TStepDesktop> = ({
    Aligner,
    Grid,
    Img,
    Text,
    TextContent,
    createTree = null,
    isNotLastItem = false,
    step,
    withSeparator = false,
}) => {
    const {
        header,
        image,
        stepImageAlign = DEFAULT_STEP_IMAGE_ALIGN,
        stepTextAlign = DEFAULT_STEP_TEXT_ALIGN,
    } = step;

    return (
        <Aligner>
            <Grid
                alignment
                collapse
                columnsWidth={getImageColumnsWidth(stepImageAlign)}
                justify="between"
                styler={{
                    marginBottom: 16,
                }}
            >
                <></>
                <Aligner align={stepImageAlign}>
                    <Img {...image} />
                </Aligner>
                <>
                    {isNotLastItem && withSeparator && (
                        <IconArrowRight height={28} role="img" width={16} />
                    )}
                </>
            </Grid>
            <Aligner align={stepTextAlign} styler={{ marginBottom: 8 }}>
                <Text styler={{ marginBottom: 0, marginTop: 0 }} tag="h3" view="small">
                    {header}
                </Text>
            </Aligner>
            <Aligner align={stepTextAlign}>
                <TextContent createTree={createTree} step={step} />
            </Aligner>
        </Aligner>
    );
};
